import React from 'react';
import PropTypes from 'prop-types';

// Modules
import Window from '../../../../../../../modules/window';

// Models
import Engagement from '../../../../../../../models/v2/engagement';

// Base
import Button from '../../../../../base/button';

export default class ApplyButton extends React.PureComponent {
  static propTypes = {
    opportunity: PropTypes.object.isRequired,
  }

  state = {
    creating: false,
  }

  handleClick = (e) => {
    e && e.preventDefault();

    const { opportunity } = this.props;
    const { creating } = this.state;

    if (creating) return;

    const data = {
      opportunity_id: opportunity.id,
    }

    this.setState({ creating: true }, () => {
      (new Engagement(data))
        .save()
        .then(({ id }) => Window.redirect(`/c/engagements/${id}`))
        .catch((error) => Window.flash.error(error));
    })
  }

  render() {
    const { creating } = this.state;

    return (
      <Button
        size='sm'
        color='primary'
        onClick={this.handleClick}
        disabled={creating}
      >APPLY NOW</Button>
    )
  }
}